export default "/images/create-event.jpg?48dcd349a84123694f79ef89430b14e0";